import PointNav from './PointNav';

export default PointNav;
